/**
 * CommonView
 */

import Config from '../Config';
import View from './View';
import User from '../User';
import GameInfo from '../GameInfo';

class CommonView extends View {

	protected _id: string;

	protected paramInfo: any;

	private writeButton: string;

	private listButton: string;

	private template: any;

	constructor( node: any, options: any, template: any ) {
		super( node, options );
		this._id = node.attr( 'id' );
		this.template = template;
	}

	public addEvent() {
		// this.writeButton = `#${this._id} .btn-write`;
		// this.listButton = `#${this._id} .co-btn-list`;
		this.writeButton = `.${Config.COMMUNITY_NODE} .co-btn-write`;
		this.listButton = `.${Config.COMMUNITY_NODE} .co-btn-list`;

		jQuery( 'body' ).on( 'click', this.listButton, ( evt ) => {
			if ( Config.board === 'event' ) {
				location.href = `${( window as any )._path || '/'}board/eventlist_running/list`;
			} else {
				let param = this.paramInfo.getParamIgnore( 'articleId' );
				param = ( param[ 0 ] === '&' ) ? param.substr( 1 ) : param;
				location.href = Config.listPage + '?' + param;
			}
		});

		jQuery( 'body' ).on( 'click', this.writeButton, ( evt ) => {
			if ( User.isCheckNotExistGameAccount() && GameInfo.isLogined() ) {
				Config.alert( Config.L10N.alert_not_exist_gameaccount );
			} else {
				this.goToWrite();
			}
		});
	}

	public goToWrite() {
		const pInfo = this.paramInfo;
		location.href = Config.writePage + '?' + pInfo.getParamIgnore( 'articleId' );
	}

	public get() {
		super.getData( this.template );
	}

	public getData() {
		return Config.viewData;
	}
}

export default CommonView;
